import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { MeResponse } from '../models/me-response.model';
import { SettingsResponse } from '../models/settings-response.model';
import { ApiResponse } from '../../modules/api-response';
import { BaseApiService } from '../base-api.service';

@Injectable({
  providedIn: 'root'
})
export class MeService extends BaseApiService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = `${this.coreApiUrl}/api/v1/users/me`;

  getMe(): Observable<MeResponse> {
    // Core wraps responses in an ApiResponse envelope; unwrap `.data` like the other services.
    return this.http.get<ApiResponse<MeResponse>>(this.apiUrl).pipe(map(response => response.data));
  }

  getSettings(): Observable<SettingsResponse[]> {
    return this.http.get<ApiResponse<SettingsResponse[]>>(`${this.apiUrl}/setting`).pipe(map(response => response.data));
  }
}
